import { SpeedDial, SpeedDialAction } from "@mui/material";
import {
  AttachMoney as FitIcon,
  CloudUpload as UploadIcon,
  Sell as SellingIcon,
  ShoppingCart as PurchaseIcon,
} from "@mui/icons-material";
import { usePriceCsv } from "./usePriceCsv";
import FilePickerDialog from "../../../components/filePickerDialog/FilePickerDialog";
import { useState } from "react";
import type { PriceType } from "../priceType";

const purchasePrices: PriceType = "purchase";
const sellingPrices: PriceType = "selling";
const fitPrices: PriceType = "fit";

function dialogTitleForPriceType(priceType: PriceType | undefined) {
  switch (priceType) {
    case "purchase":
      return "Wybierz CSV z cenami zakupu";
    case "selling":
      return "Wybierz CSV z cenami sprzedaży";
    case "fit":
      return "Wybierz CSV z cenami FIT";
    default:
      return "Wybierz CSV z cenami";
  }
}

const ProductPricesImport = () => {
  const { uploadPriceCsv, isUploadInProgress } = usePriceCsv();
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState<PriceType>();

  return (
    <div>
      <SpeedDial
        color="secondary"
        title="Importuj ceny z CSV"
        icon={<UploadIcon />}
        ariaLabel="Importuj ceny z CSV"
        direction="up"
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        aria-disabled={isUploadInProgress}
      >
        {open && (
          <SpeedDialAction
            key={purchasePrices}
            icon={<PurchaseIcon />}
            slotProps={{
              tooltip: { open, title: "Ceny zakupu" },
            }}
            onClick={() => setDialogOpen(purchasePrices)}
          />
        )}
        {open && (
          <SpeedDialAction
            key={sellingPrices}
            icon={<SellingIcon />}
            slotProps={{
              tooltip: { open, title: "Ceny sprzedaży" },
            }}
            onClick={() => setDialogOpen(sellingPrices)}
          />
        )}
        {open && (
          <SpeedDialAction
            key={fitPrices}
            icon={<FitIcon />}
            slotProps={{
              tooltip: { open, title: "Ceny FIT" },
            }}
            onClick={() => setDialogOpen(fitPrices)}
          />
        )}
      </SpeedDial>
      <FilePickerDialog
        open={!!dialogOpen}
        title={dialogTitleForPriceType(dialogOpen)}
        onClose={() => setDialogOpen(undefined)}
        onFileSelected={async (f) => {
          const data = new FormData();
          data.append("file", f, f.name);
          await uploadPriceCsv(dialogOpen!, data);
          setDialogOpen(undefined);
        }}
      />
    </div>
  );
};

export default ProductPricesImport;
